<h1 mat-dialog-title>
    {{(cls.getMultiple$('Commission') | async) + ' als CSV exportieren'}}
    <span class="spacer"></span>

</h1>
<app-detail-list-template
    [Editing]="true"
    [Inline]="true"
    [Data]="{
        Properties: [
            {
                key: 'Zeitraum',
                formControl: Form,
                options: {
                    specialInput: {
                        timeSpan: {
                            formControlFrom: Form.controls.FromDate,
                            formControlTo: Form.controls.ToDate,
                        },
                    },
                },
            },
        ],
    }"
></app-detail-list-template>
<mat-dialog-actions>
    <button app-button mat-dialog-close Inverted Color="cancel">Abbrechen</button>
    <button app-button (click)="Export()" [Disabled]="Form.invalid">Exportieren</button>
</mat-dialog-actions>
<ng-template #loading>
    <app-loading></app-loading>
</ng-template>
